"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButtonStackContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var back_button_stack_context_1 = require("../../contexts/back-button-stack-context");
var react_1 = __importDefault(require("react"));
var BackButtonStackContextProvider = function (props) {
    var stack = react_1.default.useRef([]);
    var beforeBackStack = react_1.default.useRef([]);
    return ((0, jsx_runtime_1.jsx)(back_button_stack_context_1.BackButtonStackContext.Provider, { value: {
            push: function (callback) {
                stack.current.push(callback);
                return function () {
                    stack.current = stack.current.filter(function (el) { return el !== callback; });
                };
            },
            pop: function () {
                /*
                  Because of the nature of useEffect, the first element will be the one furthest down
                  the React Tree.
                */
                var last = stack.current.shift();
                if (!last) {
                    throw new Error("Go back stack is empty - check this before popping");
                }
                return last;
            },
            isEmpty: function () {
                return stack.current.length === 0;
            },
            beforeBack: function (element) {
                beforeBackStack.current.push(element);
                return function () {
                    beforeBackStack.current = beforeBackStack.current.filter(function (el) { return el !== element; });
                };
            },
            popBeforeBack: function () {
                /*
                  Because of the nature of useEffect, the first element will be the one furthest down
                  the React Tree.
                */
                var last = beforeBackStack.current.shift();
                if (!last) {
                    throw new Error("Go back stack is empty - check this before popping");
                }
                return last;
            },
            beforeBackIsEmpty: function () {
                return beforeBackStack.current.length === 0;
            },
        }, children: props.children }));
};
exports.BackButtonStackContextProvider = BackButtonStackContextProvider;
